/*
 * Copyright © 2015-2025 Serenova, LLC. All rights reserved.
 */

/**
 *
 * CxQmForm
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { DetailHeader, ToggleField } from 'cx-ui-components';
import DetailWrapper from '../../../../components/DetailWrapper';
import styled from 'styled-components';

const WrappedDetailHeader = styled(DetailHeader)`
    margin-left: 35px;
`;

export default function CxQmForm({isSaving, inherited,  userHasUpdatePermission}) {
  return (
    <DetailWrapper open data-automation="restPropertiesSVG">
      <WrappedDetailHeader text="Properties" />
      <ToggleField
        name="properties.qmStereoRecordingEnabled"
        label="Enable Stereo Recording"
        data-automation="integrationsCxQmEnableStereoRecording"
        disabled={isSaving || inherited || !userHasUpdatePermission}
      />
    </DetailWrapper>
  );
}

CxQmForm.propTypes = {
  isSaving: PropTypes.bool,
  inherited: PropTypes.bool,
  userHasUpdatePermission: PropTypes.bool,
};
